/*------------------------------------------------------------------*\
|| 							Posts Per Page 							||
\*------------------------------------------------------------------*/


/*----------------------------------*\
||  1.0 Variables                   ||
\*----------------------------------*/

var $doc            = $(document),
    $window         = $(window),
    logged_in       = $('body').attr('data-user-logged-in'),
    PostsPerPage    = '',
    $selectWrapper  = $('.custom-select-wrapper'),
    $select         = $('.custom-select'),
    $ul             = $('.custom-choices');


/*----------------------------------*\
||  2.0 Functions                   ||
\*----------------------------------*/

function getAmount() {
    $.ajax({
        type: 'GET',
        url:  KWR.ajaxurl,
        dataType: 'json',
        data: {
            action: 'getPPP',
        },

        success: function(response){
            if(response.success === true ) {

                PostsPerPage = response.data.amount;

                return PostsPerPage;
            }
        },

        error: function(response){
            PostsPerPage = '';
            return PostsPerPage;
        }
    }).done(function(response){
        var ppp;
        if ( logged_in == 1 && ppp !== '' ) {
            ppp = response.data.amount;
        } else {
            // ppp = localStorage.getItem('posts_per_page');
            ppp = readCookie('posts_per_page');
        }
        if ( ppp !== '' ) {
            $ul.children('li').removeClass('selected');
            $ul.children('li[data-value='+ppp+']').addClass('selected');
            $select.children('.number').text( ppp );
        } else {
            $ul.children('li').removeClass('selected');
            $ul.children('li[data-value="25"]').addClass('selected');
            $select.children('.number').text( '25' );
        }
    });
}

function setAmount( ref, amount ) {

    console.log('setAmount function');

    $.when( callback()).done(changeAmount(), function(){ return true; } );

    function callback(){
        if ( logged_in == 1 ) {
            $.ajax({
                type: 'POST',
                url:  KWR.ajaxurl,
                dataType: 'json',
                data: {
                    action: 'setPPP',
                    posts_per_page: amount
                },

                success: function(response){
                    return true;
                },

                error: function(response){
                    // console.log( response );
                }
            });
        } else {
            // addToStorage('posts_per_page', amount, null );
        }

        console.log('ajax call finished');
    }

    function changeAmount(){
        eraseCookie('posts_per_page');
        createCookie('posts_per_page', amount, 36500);
        ref.addClass('selected');
        ref.parent().prev('.custom-select').children('.number').text( amount );
        console.log('second function finished');
    }
}


/*----------------------------------*\
||  3.0 Events                      ||
\*----------------------------------*/

/**
*   Use the default posts per page amount set by user
*   First check if there is logged in user with a stored value
*   Then check if there is a value stored in the users localStorage
*   Then Either set one of the values, or leave it as is.
**/
if ( $('body').hasClass('page-template-publicaties') || $('body').hasClass('publication') ) {
    $(getAmount());
}

$doc.ready(function(jQuery) {

    /**
    *   On click:
    *   Show the choices of the dropdown
    **/
    $select.on('click', function(a){
        if ( !$(this).parent().hasClass('active') ) {
            $ul.slideDown(300);
            $(this).parent().addClass('active');
        } else {
            $ul.slideUp(300);
            $(this).parent().removeClass('active');
        }
    });

    /**
    *   On click:
    *   Use the selected value as post per page amount and update localStorage
    *   Set the correct option to selected
    **/
    $ul.children('li').on('click', function(d){
    	var posts_per_page = $(this).data("value");

        $ul.slideUp(300).children('li').removeClass('selected');
        $selectWrapper.removeClass('active');

        $.when( setAmount( $(this), posts_per_page ) )
        .done( location.reload() );
        
    });

});